import { Nota, Tabela, Tag, Td } from '../../shared/ui/primitivas';
import { TelaAnery } from '../../shared/ui/TelaAnery';
import type { AneryChip, AneryTag } from '../../shared/ui/tiposDaEsteira';

/** Fronteira da fonte: vira `useQuery` aqui quando `GET /prestadores` existir. */
const PRESTADORES = {
  breadcrumb: 'operação / prestadores / fechamento · prazo dia 20',
  titulo: 'Fechamento de prestadores — comparador planilha × IW',
  subtitulo:
    'As planilhas chegam por e-mail e alguém audita paciente a paciente no IW. Aqui o comparador traz só o que diverge, já classificado. Quem conferiu passa direto.',
  chips: [
    { label: 'prazo ', strong: 'dia 20' },
    { label: 'só prestadores de pacientes Bradesco' },
    { label: 'a maior dor: nível e bonificação' },
  ] as AneryChip[],
  linhas: [
    {
      prestador: 'Coop. Enfermagem SP',
      categoria: 'Técnico enf.',
      planilha: '312',
      iw: '312',
      delta: '—',
      classificacao: { label: 'conferido', tone: 'ok' },
    },
    {
      prestador: 'Dr. Almeida',
      categoria: 'Médico',
      planilha: '28',
      iw: '31',
      delta: '−3',
      classificacao: { label: 'tablet não sincronizado', tone: 'warn' },
    },
    {
      prestador: 'Fisio Movimento',
      categoria: 'Fisioterapia',
      planilha: '146',
      iw: '148',
      delta: '−2',
      classificacao: { label: 'comprovante físico pendente', tone: 'warn' },
    },
    {
      prestador: 'Nutri Vida',
      categoria: 'Nutrição',
      planilha: '54',
      iw: '54',
      delta: '—',
      classificacao: { label: 'conferido', tone: 'ok' },
    },
    {
      prestador: 'Coop. Enfermagem RJ',
      categoria: 'Técnico enf.',
      planilha: '203',
      iw: '203',
      delta: '—',
      classificacao: { label: 'nível errado no orçamento', tone: 'block' },
    },
    {
      prestador: 'Home Care Norte',
      categoria: 'Multi',
      planilha: '89',
      iw: '89',
      delta: '—',
      classificacao: { label: 'bonificação não lançada', tone: 'block' },
    },
  ] as {
    prestador: string;
    categoria: string;
    planilha: string;
    iw: string;
    delta: string;
    classificacao: AneryTag;
  }[],
  nota: 'Fechamento em 1,8 dia útil contra 6+ em planilha, e o erro de orçamento — nível errado, bonificação não lançada — aparece antes da NF em vez de no fechamento. "Quem pega termina" vira fila com dono, sem colidir com férias.',
};

export function PaginaDePrestadores(): React.JSX.Element {
  return (
    <TelaAnery
      breadcrumb={PRESTADORES.breadcrumb}
      titulo={PRESTADORES.titulo}
      subtitulo={PRESTADORES.subtitulo}
      chips={PRESTADORES.chips}
    >
      {/* Ordem das colunas: planilha · IW · Δ. Conferência se lê um lado
          contra o outro; com o Δ no fim, os três números da mesma conta
          ficavam separados por coluna de texto e o olho tinha que voltar. */}
      <Tabela
        colunas={[
          { rot: 'Prestador' },
          { rot: 'Categoria' },
          { rot: 'Planilha', num: true },
          { rot: 'IW', num: true },
          { rot: 'Δ', num: true },
          { rot: 'Classificação' },
        ]}
      >
        {PRESTADORES.linhas.map((l) => (
          <tr key={l.prestador}>
            <Td>{l.prestador}</Td>
            <Td fraco>{l.categoria}</Td>
            <Td num>{l.planilha}</Td>
            <Td num>{l.iw}</Td>
            <Td num>{l.delta}</Td>
            <Td>
              <Tag {...l.classificacao} />
            </Td>
          </tr>
        ))}
      </Tabela>

      <Nota titulo="O que muda.">{PRESTADORES.nota}</Nota>
    </TelaAnery>
  );
}
